'use strict';

export default {
  userForms: [
    {
      id: 'userAgreement',
      name: 'Sähköisen asioinnin suostumus',
      icon: 'icon-file',
      fieldGroups: [
        {
          key: 1,
          fields: [
            {
              key: 1,
              name: 'userAgreement',
              id: 'userAgreement',
              label: '',
              type: 'radio',
              values: [
                {
                  id: 'agree',
                  value: 'ACCEPTED',
                  label: 'userAgreementAgree',
                },
                {
                  id: 'deny',
                  value: 'NO_MESSAGES',
                  label: 'userAgreementTextAndEmailDeny',
                },
              ],
              defaultValue: true,
              className: 'span12',
            },
          ],
          divide: false,
        },
      ],
      buttons: {
        open: [
          {
            text: 'Peruuta',
            action: 'cancel',
            className: 'ot-button ot-button--gray pull-left',
          },
          {
            text: 'Tallenna',
            action: 'saveUserAgreement',
            className: 'ot-button ot-button--light pull-left',
          },
          {
            text: 'Peruuta suostumus',
            action: 'cancelUserAgreement',
            className: 'ot-button pull-right',
          },
        ],
        closed: [
          {
            text: 'Muokkaa suostumusta',
            action: 'open',
            className: 'ot-button ot-button--light pull-left',
          },
        ],
      },
      status: `Hyväksytty`,
    },
    {
      id: 'relatives',
      name: 'Yhteyshenkilöni',
      icon: 'icon-user',
      fieldGroups: [
        {
          key: 1,
          fields: [
            {
              key: 2,
              name: 'name',
              id: 'name',
              label: 'Yhteyshenkilösi nimi',
              type: 'input',
              disabled: true,
              defaultValue: '',
              className: 'span6',
            },
            {
              key: 1,
              name: 'phone',
              id: 'phone',
              label: 'Yhteyshenkilön puhelinnumero',
              disabled: true,
              type: 'input',
              defaultValue: '',
              className: 'span6',
            },
          ],
          divide: false,
          repeatable: true,
        },
        {
          key: 2,
          fields: [
            {
              key: 2,
              name: 'contactPersonInfo',
              id: 'contactPersonInfo',
              type: 'info',
              description:
                '*Jos haluat vaihtaa tai lisätä yhteyshenkilöitä tai päivittää heidän yhteystietojaan, ota yhteyttä hoitoyksikköösi.',
              className: 'span12',
            },
          ],
          divide: false,
        },
      ],
      /*buttons: {
        open: [{ text: "Sulje yhteyshenkilöni", action: "close" }],
        closed: [{ text: "Näytä yhteyshenkilöni", action: "open" }],
      },*/
    },
  ],
};
